import { render, staticRenderFns } from "./PagePositions.vue?vue&type=template&id=ab9ef7de"
import script from "./PagePositions.vue?vue&type=script&lang=js"
export * from "./PagePositions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports